export const SAVED = () => `The client CDN configurations have been added successfully.`;
export const NOT_SAVED = () => `The client CDN configurations could not be added.`;
